module.exports = __webpack_public_path__ + "img/JP.bf2877e2.svg";